import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReportCommonOptionsInputFormComponent} from './report-common-options-input-form.component';
import {FormModule} from '../../../../../form/form.module';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {IonicModule} from '@ionic/angular';
import {
    ReportAccountComponentSelectFilterModule
} from '../../../../report-account-component/api/component/report-account-component-select-filter/report-account-component-select-filter.module';
import {
    ReportComponentSelectFilterModule
} from '../../../../report-component/api/component/report-component-select-filter/report-component-select-filter.module';

@NgModule({
    imports: [
        CommonModule,
        FormModule,
        ReactiveFormsModule,
        FormFieldModule,
        ReportAccountComponentSelectFilterModule,
        IonicModule,
        ReportComponentSelectFilterModule,
    ],
    declarations: [ReportCommonOptionsInputFormComponent],
    exports: [
        ReportCommonOptionsInputFormComponent
    ]
})
export class ReportCommonOptionsInputFormModule {
}
